export default {
	Title: 'Vai trò quyền hạn',
	NoRoleFound: 'Không tìm thấy vai trò quyền hạn',
	RoleDetail: {},
	RoleList: {
		AddNew: 'Thêm mới',
		AddRole: 'Thêm vai trò'
	},
	AddRoleTitle: 'Thêm vai trò quyền hạn',
	EditRoleTitle: 'Sửa vai trò quyền hạn'
};
